module.exports = __webpack_public_path__ + "img/bw.59e786f1.png";